//文字コードはutf-8

/* ファイルアップロードのドラッグ&ドロップ（Contact Form 7 の [file] 用）
 * - CF7 本体に D&D 機能は無いため、ドロップされたファイルを DataTransfer 経由で
 *   input[type="file"] に流し込む。以降の検証・送信は CF7 がそのまま処理するので
 *   CF7 側のフック等は不要。
 * - .modForm__file          : グレー枠 + ボタン + 注釈のまとまり
 * - .modForm__file__drop    : ドロップ枠。クリックでもファイル選択を開く（「ファイルを選択」ラベルは既定動作）
 * - 形式・サイズの検証は CF7（filetypes: / limit:）のサーバー側に任せる。
========================================================*/

const FIELD_SELECTOR = '.modForm__file';
const DRAG_CLASS = 'is-dragover';

export function initFileUpload() {
    const fields = document.querySelectorAll(FIELD_SELECTOR);
    if (!fields.length) return;

    fields.forEach(setupField);
    preventWindowDrop();
}

function setupField(field) {
    if (field.dataset.fileReady) return; // 二重適用防止

    const input = field.querySelector('input[type="file"]');
    const drop = field.querySelector('.modForm__file__drop');
    if (!input || !drop) return;
    field.dataset.fileReady = '1';

    // 選択したファイル名の表示欄は空の要素を DOM に残さず、ファイルがある時だけ
    // JS で生成する。挿入位置はリード文の直後（アクションの前）に合わせる。
    const actions = drop.querySelector('.modForm__file__actions');

    // 枠内クリックでもファイル選択を開く。
    // 「ファイルを選択」ラベルはネイティブに input を開くため、二重オープンを防ぐ
    drop.addEventListener('click', (e) => {
        if (e.target.closest('label')) return;
        input.click();
    });

    if (typeof DataTransfer !== 'undefined') {
        ['dragenter', 'dragover'].forEach((type) => {
            drop.addEventListener(type, (e) => {
                if (!hasFiles(e)) return;
                e.preventDefault(); // これが無いとブラウザがファイルを開いてしまう
                e.dataTransfer.dropEffect = 'copy';
                drop.classList.add(DRAG_CLASS);
            });
        });

        ['dragleave', 'dragend'].forEach((type) => {
            drop.addEventListener(type, (e) => {
                // 子要素へ移動しただけの dragleave では外さない
                if (type === 'dragleave' && drop.contains(e.relatedTarget)) return;
                drop.classList.remove(DRAG_CLASS);
            });
        });

        drop.addEventListener('drop', (e) => {
            if (!hasFiles(e)) return;
            e.preventDefault();
            drop.classList.remove(DRAG_CLASS);

            const file = e.dataTransfer.files[0]; // CF7 の [file] は1ファイルのみ
            if (!file) return;
            assignFile(input, file);
        });
    }

    input.addEventListener('change', render);

    // CF7 は送信成功後にフォームをリセットするため、表示も元へ戻す
    const form = input.closest('form');
    if (form) {
        form.addEventListener('wpcf7mailsent', resetLater);
        form.addEventListener('reset', resetLater);
    }

    // input.files がクリアされるのはイベント処理の後なので1tick待つ
    function resetLater() {
        setTimeout(render, 0);
    }

    function render() {
        const file = input.files && input.files[0];
        let nameEl = drop.querySelector('.modForm__file__name');
        if (file) {
            // ファイルがある時だけ要素を生成（無ければ作ってリード文の直後へ挿入）
            if (!nameEl) {
                nameEl = document.createElement('p');
                nameEl.className = 'modForm__file__name';
                drop.insertBefore(nameEl, actions);
            }
            nameEl.textContent = file.name;
        } else if (nameEl) {
            // ファイルが無くなったら要素ごと取り除く（空要素を残さない）
            nameEl.remove();
        }
    }
}

// ドロップされたファイルを input へ流し込む。
// input.files はここでしか書き換えられない（DataTransfer 経由が唯一の手段）
function assignFile(input, file) {
    const dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
    // 選択が変わったことを CF7 とページ側へ通知する
    input.dispatchEvent(new Event('change', { bubbles: true }));
}

// ドラッグ中のデータにファイルが含まれるか
function hasFiles(e) {
    const dt = e.dataTransfer;
    if (!dt) return false;
    return Array.from(dt.types || []).includes('Files');
}

// 枠の外へ落とした時にブラウザがファイルを開いてしまうのを防ぐ
function preventWindowDrop() {
    if (document.body.dataset.fileDropGuard) return;
    document.body.dataset.fileDropGuard = '1';

    ['dragover', 'drop'].forEach((type) => {
        window.addEventListener(type, (e) => {
            if (!hasFiles(e)) return;
            if (e.target.closest && e.target.closest('.modForm__file__drop')) return;
            e.preventDefault();
            if (type === 'drop') e.dataTransfer.dropEffect = 'none';
        });
    });
}
